import React, { Component } from 'react';
import Style from './CredentialMonitoring.module.css';
import EnterIcon from '../../assets/Enter_Arrow_Right.svg';
import { connect } from 'react-redux'
import SearchBox from '../common/searchBox/searchBox';
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';
import Pagination from '../common/paginator/pagination';
import SolidUp from '../../assets/Arrow_up_solid.svg';
import SolidDown from '../../assets/Arrow_down_solid.svg';


class RiskProfiles extends Component {

    onActionClick = (record) => {
        const { onActionClick } = this.props;
        onActionClick(record);
    }

    renderSortIcon = (fieldName) => {
        const { sortField, sortOrder } = this.props;
        const isActive = sortField === fieldName;
        
        if (!isActive) {
            return (
                <img 
                    style={{ width: '18px', marginLeft: '5px' }} 
                    src={SolidUp} 
                    alt="Sort" 
                />
            );
        }
        
        return (
            <img 
                style={{ width: '18px', marginLeft: '5px' }} 
                src={sortOrder === 'asc' ? SolidUp : SolidDown} 
                alt={sortOrder === 'asc' ? 'Sorted Ascending' : 'Sorted Descending'} 
            />
        );
    }

    getTableDef = () => ({
        name: 'aggregateCompromisedLoginsGrid',
        columns: [
            { 
                fieldName: 'userId', 
                displayName: (
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.props.handleSort('uId')}>
                        User Name
                        {this.renderSortIcon('uId')}
                    </div>
                ),
                dataType: 'string', 
                width: '20%', 
                className: Style.fontBold 
            },
            { 
                fieldName: 'totalLogins', 
                displayName: (
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.props.handleSort('ttLgns')}>
                        Total Logins
                        {this.renderSortIcon('ttLgns')}
                    </div>
                ),
                dataType: 'string', 
                width: '15%' 
            },
            { 
                fieldName: 'cmpPwd', 
                displayName: (
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.props.handleSort('cmpPwd')}>
                        No. Compromised Passwords
                        {this.renderSortIcon('cmpPwd')}
                    </div>
                ),
                dataType: 'string', 
                width: '15%' 
            },
            { 
                fieldName: 'weakPwd', 
                displayName: (
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.props.handleSort('wkPwd')}>
                        No. Weak Passwords
                        {this.renderSortIcon('wkPwd')}
                    </div>
                ),
                dataType: 'string', 
                width: '15%' 
            },
            {
                fieldName: 'safePwd',
                displayName: (
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.props.handleSort('safePwd')}>
                        No. Safe Passwords
                        {this.renderSortIcon('safePwd')}
                    </div>
                ),
                dataType: 'string',
                width: '15%'
            },
            {
                fieldName: 'Details',
                displayName: 'Details',
                dataType: 'image',
                src: EnterIcon,
                width: '10%',
                onClick: this.onActionClick
            }
        ]
    })

    handleSearch = (searchText) => {
        let { handleSearch } = this.props;
        if (handleSearch) {
            handleSearch(searchText);
        }
    }

    renderTableHeader = () => {
        const tableDef = this.getTableDef();
        return (
            <thead>
                <tr>
                    {tableDef.columns.map((column, index) => (
                        <th key={index} style={{ width: column.width }}>
                            {column.displayName}
                        </th>
                    ))}
                </tr>
            </thead>
        );
    }

    renderTableRow = (record, rowIndex) => {
        const tableDef = this.getTableDef();
        return (
            <tr key={rowIndex}>
                {tableDef.columns.map((column, colIndex) => {
                    if (column.dataType === 'image') {
                        return (
                            <td key={colIndex} style={{ width: column.width, cursor: 'pointer' }}>
                                <img 
                                    src={column.src} 
                                    alt={column.displayName}
                                    style={{ width: '24px', cursor: 'pointer' }}
                                    onClick={() => column.onClick && column.onClick(record)}
                                />
                            </td>
                        );
                    }
                    
                    return (
                        <td 
                            key={colIndex} 
                            style={{ width: column.width }}
                            className={column.className || ''}
                        >
                            {record[column.fieldName] || 0}
                        </td>
                    );
                })}
            </tr>
        );
    }

    renderTable = () => {
        const { riskProfiles } = this.props;
        
        return (
            <div style={{ marginTop: '20px' }}>
                <table className="table" style={{ width: '100%' }}>
                    {this.renderTableHeader()}
                    <tbody>
                        {riskProfiles.map((record, index) => this.renderTableRow(record, index))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderRiskProfiles = () => {
        let { riskProfiles, loading, pageNo, pageSize, isLastPage, getPrevPageData, getNextPageData, resetOnChange} = this.props;

        return (
            <div>

                <div style={{ minHeight: '600px', padding: '30px' }}>
                    <div id={Style.searchBox} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#ffffff'}}> 
                        <div style={{width: '60%', display: 'flex', alignItems: 'center'}}>
                            <div className="d-flex" style={{height: '40px', width: '60%'}}>
                                <SearchBox style={{width: '100%'}}
                                    placeholder="Search User"
                                    value={this.props.srchTxt}
                                    handleSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                </div>
                    {loading ? 
                        <LoaderWrapper
                            loading={loading} data={riskProfiles ? riskProfiles : []}
                            styles={{ minHeight: '500px', padding: '30px' }} placeholderText={"No Compromised Logins Detected"}
                        />  
                    : riskProfiles.length === 0 ? (
                        <div className={Style.emptyState}>
                            <div className={Style.emptyStateText}>
                                No aggregate compromised logins detected
                            </div>
                        </div>
                    ) : (
                        <>
                            {this.renderTable()}
                            <div>
                            <Pagination 
                                initialPageNo={pageNo}
                                resetOnChange={resetOnChange} 
                                isLastPage={isLastPage} 
                                pageSize={pageSize}
                                getPrevPageData={getPrevPageData} 
                                getNextPageData={getNextPageData} 
                                loaderFlag={loading}
                            />
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }

    render() {
        return this.renderRiskProfiles();
    }
}

export default RiskProfiles;